import dayjs from 'dayjs'

export default {
  // blob转base64
  blobToBase64: function (blob) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        resolve(e.target.result)
      }
      // readAsDataURL
      fileReader.readAsDataURL(blob)
      fileReader.onerror = () => {
        reject(new Error('blobToBase64 error'))
      }
    })
  },
  // 获取访问地址的参数
  getQueryVariable: function (variable) {
    var query = window.location.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] === variable) { return pair[1] }
    }
    return (false)
  },
  // 改变base64图片精度
  suofang: function (base64, bili, callback) {
    // 处理缩放，转格式
    var _img = new Image()
    _img.src = base64
    _img.onload = function () {
      var _canvas = document.createElement('canvas')
      var w = this.width / bili
      var h = this.height / bili
      _canvas.setAttribute('width', w)
      _canvas.setAttribute('height', h)
      _canvas.getContext('2d').drawImage(this, 0, 0, w, h)
      var base64 = _canvas.toDataURL('image/jpeg')
      if (base64.length > 1000) {
        this.suofang(base64, bili, callback)
      } else {
        let img = `<img style='width:220px;height: auto;' onclick="showImage('${base64}')" src='${base64}'>`
        var inputData = { 'UserId': '123', 'ImageContent': img }
        callback(inputData)
      }
      /* _canvas.toBlob(function(blob) {
                console.log(blob.size);

            }, "image/jpeg"); */
    }
  },
  // base64转file
  base64ToFile: function (base64Data) {
    // eslint-disable-next-line one-var
    let arr = base64Data.split(','),
      fileType = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      l = bstr.length,
      u8Arr = new Uint8Array(l)

    while (l--) {
      u8Arr[l] = bstr.charCodeAt(l)
    }
    let newBlob = new Blob([u8Arr], {
      type: fileType
    })
    newBlob.lastModifiedDate = new Date()
    newBlob.name = '截图'
    return newBlob
  },
  // iframe向父页面发送消息
  postToParent: function (data) {
    top.postMessage(data, '*')
  },
  // iframe接收父页面发来的消息
  getMessageFromParent: function (func) {
    window.addEventListener('message', func, false)
  },
  // 去抖动
  debounce: function (action, delay) {
    var timer = null
    return function () {
      // eslint-disable-next-line one-var
      var self = this,
        args = arguments

      clearTimeout(timer)
      timer = setTimeout(function () {
        action.apply(self, args)
      }, delay)
    }
  },
  // 判断传输进来的时间与当前时间的关系 //0:今天，1：昨天 2：前天 3、三天以前
  judgeTime: function (time) {
    // eslint-disable-next-line no-undef
    let now = dayjs().format('YYYY-MM-DD')
    let newTime = time.substring(0, 10)
    // eslint-disable-next-line no-undef
    if (dayjs(now).diff(newTime, 'day') === 0) { // 今天
      return 0
    // eslint-disable-next-line no-undef
    } else if (dayjs(now).diff(time, 'day') === 1) { // 昨天
      return 1
    // eslint-disable-next-line no-undef
    } else if (dayjs(now).diff(time, 'day') === 2) {
      return 2
    } else {
      return 3
    }
  },
  strToColor (str) {
    if (!str || typeof str !== 'string') return 'rgba(30,66,173,1)'
    let s = str.length < 3 ? str + str + str : str
    const sarr = s.split('')
    const sarrNum = []
    for (let i = 0; i < 3; i++) {
      // 字符传转数字，由于字母转的数字比较小，做乘以6换算。因为色值不能高于255，取余255
      sarrNum.push((stringTonum(sarr[i]) * 6) % 255)
    }
    if (sarrNum[0] > 200 && sarrNum[1] > 200 && sarrNum[2] > 200) {
      // 避免亮度过高
      sarrNum[2] = 25
    } else if (sarrNum[0] < 50 && sarrNum[1] < 50 && sarrNum[2] < 50) {
      // 避免亮度过低
      sarrNum[2] = 170
    }

    return `rgba(${sarrNum[0]},${sarrNum[1]},${sarrNum[2]},1)`
  }
}
// 字符转数字
function stringTonum (a) {
  var str = a.toLowerCase().split('')
  var al = str.length
  var getCharNumber = function (charx) {
    return charx.charCodeAt() - 96
  }
  var numout = 0
  var charnum = 0
  for (var i = 0; i < al; i++) {
    charnum = getCharNumber(str[i])
    numout += charnum * Math.pow(26, al - i - 1)
  }
  return numout
}



//////////////////
// WEBPACK FOOTER
// ./packages/utils/utils.js
// module id = null
// module chunks = 